import { useRoutes } from 'react-router-dom'
import { appRoutes } from './app.routes'
import { onboardingRoutes } from './onboarding.routes'
import { publicRoutes } from './public.routes'

/**
 * The complete route tree. Public routes are declared first so they win over
 * the authenticated shell's catch-all, followed by the chrome-free onboarding
 * routes and finally the authenticated application shell.
 */
export function AppRoutes() {
  return useRoutes([...publicRoutes, ...onboardingRoutes, ...appRoutes])
}
